import { LogOutIcon } from 'lucide-react'

import { DashboardLayout } from 'shared/dashboard/Layout'
import { ProfileDropdown } from 'shared/dashboard/ProfileDropdown'
import { useBreakpoint } from 'slab'

interface FallbackAppLayoutProps {
  children?: React.ReactNode;
}

function SkeletonNavItem ({ width = 'w-full' }: { width?: string }) {
  return (
    <div className={`h-9 ${width} bg-gray-800/5 rounded-md`} />
  )
}

export function FallbackAppLayout ({ children }: FallbackAppLayoutProps) {
  const { breakpointIsAtLeast } = useBreakpoint()

  return (
    <DashboardLayout>
      {breakpointIsAtLeast('md')
        ? (
          <DashboardLayout.Sidebar>
            <div className='flex flex-col h-full'>
              <div className='p-3 border-b border-gray-200'>
                <ProfileDropdown
                  name={(
                    <div className='h-5 w-28 bg-gray-800/5 rounded-md' />
                )}
                >
                  <ProfileDropdown.Item
                    leftIcon={LogOutIcon}
                    onSelect={() => {}}
                  >
                    Sign out
                  </ProfileDropdown.Item>
                </ProfileDropdown>
              </div>
              <div className='flex flex-col gap-1 p-3'>
                <SkeletonNavItem />
                <SkeletonNavItem />
                <SkeletonNavItem />
                <SkeletonNavItem />
                <SkeletonNavItem />
              </div>
              <div className='mt-auto p-3 border-t border-gray-200'>
                <div className='h-14 w-full bg-gray-800/5 rounded-md' />
              </div>
            </div>
          </DashboardLayout.Sidebar>
          )
        : <DashboardLayout.MobileNavBar />}
      <DashboardLayout.Main>
        {children}
      </DashboardLayout.Main>
    </DashboardLayout>
  )
}
